export default __webpack_public_path__ + "static/media/css.fca023f9.png";